import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import Modal from "react-bootstrap/Modal";
import XCircleblack from "../../../../../src/Components/IconComponents/XCircleblack";
import {
  Editicon,
  Deleteicon,
  Viewicon,
} from "../../../../Components/IconComponents";
import { History as HistoryIcon, Filter as FilterIcon, Sheet, FileText } from "lucide-react";
import { getCategoryBadgeStyle, getSeverityBadgeStyle } from "../../Common/badgeStyles";
import { toast, ToastContainer } from "react-toastify";
import Table from "../../../../Components/UiComponents/Table/Table";
import Moment from "react-moment";
import Loader from "react-spinner-loader";
import {
  SOPTableData,
  sopcolumnsForExport,
} from "../../../../JsonData/SOPConfig";
import { getData, putDataWithBody } from "../../../../Services/Services";
import {
  getMasterSOPListURL,
  getActiveSOPsList,
  getDeletedSOPsList,
  deleteSopById,
  getThemeURL,
} from "../../../../Services/EndPoints";
import { useDispatch } from "react-redux";
import { getExportedColumnsData } from "../../../../Components/UiComponents/utils";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import StatusHandler from "../../Common/StatusHandler/StatusHandler";
import { useTranslation } from "react-i18next";
import { RoleContext, ThemeContext } from "../../../..";
import { Button } from "react-bootstrap";
import SOPExpandableTable from "./SOPExpandableTable";
import SopResourceAuditHistoryModal from "./SopResourceAuditHistoryModal";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

// Local (not UTC) today as YYYY-MM-DD — the UTC date is a day behind for part of the day in IST.
const TODAY_STR = (() => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
})();
// Typing a future date into a native date input bypasses `max`, so clamp it here.
const clampToToday = (v) => (v && v > TODAY_STR ? TODAY_STR : v);

const SOP_LIST_EXPORT_COLUMNS = [
  "SOP Master ID",
  "SOP Name",
  "Incident Category",
  "Severity",
  "SOP Status",
  "Created On",
  "Resource Name",
  "Available Qty",
  "Damaged Qty",
  "Deployed Qty",
  "Total Qty",
  "Qty To Deploy",
  "Auto",
  "Manual",
];

const isTruthyFlagYesNo = (v) => (v === true || v === 1 || v === "true" ? "Yes" : "No");

const exportFileStamp = () => {
  const p = (n) => String(n).padStart(2, "0");
  const n = new Date();
  return `${p(n.getDate())}-${p(n.getMonth() + 1)}-${n.getFullYear()}_${p(n.getHours())}${p(
    n.getMinutes()
  )}${p(n.getSeconds())}`;
};

const filterLabelStyle = {
  fontSize: "9.5px",
  fontWeight: 800,
  letterSpacing: ".3px",
  textTransform: "uppercase",
  color: "#98A2B3",
};

const filterControlStyle = {
  padding: "6px 10px",
  borderRadius: "8px",
  border: "1px solid #E4E7EC",
  fontSize: "12px",
  background: "#fff",
  color: "#1D2939",
  height: "34px",
  boxSizing: "border-box",
};

const exportBtnBase = {
  height: "34px",
  width: "34px",
  padding: 0,
  fontSize: "12px",
  fontWeight: 600,
  borderRadius: "6px",
  cursor: "pointer",
  boxSizing: "border-box",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};
const excelExportBtnStyle = { ...exportBtnBase, border: "1px solid #10B981", color: "#fff", background: "#10B981" };
const pdfExportBtnStyle = { ...exportBtnBase, border: "1px solid #dc3545", color: "#fff", background: "#dc3545" };
const exportBtnDisabledStyle = { ...exportBtnBase, border: "1px solid #e5e9ef", color: "#aab4bf", background: "#f4f6f8", cursor: "not-allowed" };

const SOPTable = forwardRef((props, ref) => {
  const { roleName } = useContext(RoleContext);
  const dispatch = useDispatch();
  const qs = require("qs");
  const [SOPData, setSOPData] = useState([]);
  const [inactiveSOPData, setInactiveSOPData] = useState([]);
  const { theme } =useContext(ThemeContext);
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [rowCount, setRowCount] = useState(0);
  const [searchData, setSearchData] = useState([]);
  const [historyRow, setHistoryRow] = useState(null);
  // Category/Severity/Status filter dropdowns apply immediately on selection.
  const [categoryFilter, setCategoryFilter] = useState("All");
  const [severityFilter, setSeverityFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  // Date range only takes effect once "Apply" is clicked — pending values are
  // what the inputs show, applied values are what actually filters the data.
  const [pendingDateFrom, setPendingDateFrom] = useState("");
  const [pendingDateTo, setPendingDateTo] = useState("");
  const [appliedDateFrom, setAppliedDateFrom] = useState("");
  const [appliedDateTo, setAppliedDateTo] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    if (props.locationInstance && props.locationInstance.msg != "") {
      toast.success("Agency has been created successfully.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Close after 2 seconds...
      });
    }
    getSOPMasterList();
  }, []);

  useEffect(() => {
    sendDataToCentralStore(searchData);
  }, [searchData]);

  const addNewHandler = () => {
    navigate("/planning/create-sop");
  };
  const openSOPDataTable = async () => {
    setShow(true);
  };
  const getShortenedText = (strLength, fulltext) => {
    let abbreviatedText = "";
    if (fulltext.length > strLength) {
      abbreviatedText = fulltext.substring(0, 95) + "...";
    } else {
      abbreviatedText = fulltext;
    }
    return <span title={fulltext}>{abbreviatedText}</span>;
  };
  const hideModal = () => {
    setShow(false);
  };
  const sortByCreatedOn = (list) =>
    (Array.isArray(list) ? list : []).sort(
      (a, b) => new Date(b.created_on) - new Date(a.created_on)
    );

  const getSOPMasterList = async () => {
    setLoader(true);
    try {
      const userProfile = await getData(getThemeURL);
      const state_id = userProfile[0]?.state_id;
      const [activeList, deletedList] = await Promise.all([
        getData(`${getActiveSOPsList}/${state_id}`),
        getData(`${getDeletedSOPsList}/${state_id}`),
      ]);

      const sortedActive = sortByCreatedOn(activeList).map((item) => ({
        ...item,
        isDeleted: false,
      }));
      const sortedDeleted = sortByCreatedOn(deletedList).map((item) => ({
        ...item,
        isDeleted: true,
      }));

      setSOPData(sortedActive);
      setInactiveSOPData(sortedDeleted);
      setRowCount(sortedActive.length);
    } catch (error) {
      console.error("Error fetching SOP master list:", error);
    } finally {
      setLoader(false);
    }
  };

  const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      const columns = sopcolumnsForExport;
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, data),
        })
      );
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "SOP Master ID",
        accessor: "sopmaster_seq_id",
        disableSortBy: true,
      },
      {
        Header: t("sopmanagementtableheaders.name"),
        accessor: "name",
        disableSortBy: true,

        Cell: (props) => {
          return (
            <span /*onClick={() => openSOPDataTable(props.value)}*/>
              {props.value}
            </span>
          );
        },
      },

      // {
      //   Header: t("sopmanagementtableheaders.description"),
      //   accessor: "description",
      //   disableSortBy: true,
      // },
      {
        Header: t("sopmanagementtableheaders.incident_type") || "Incident Category",
        accessor: "incident_type",
        Cell: (props) => {
          return props.value ? <span style={getCategoryBadgeStyle(props.value)}>{props.value}</span> : "NA";
        },
        disableSortBy: true,
      },
      {
        Header: t("sopformlabels.severity") || "Incident Priority",
        accessor: "severity",
        Cell: (props) => {
          return props.value ? <span style={getSeverityBadgeStyle(props.value)}>{props.value}</span> : "NA";
        },
        disableSortBy: true,
      },
      {
        Header: "SOP Status",
        accessor: "is_running",
        disableSortBy: true,
        Cell: (props) => {
          const isRunning = props.value === true;
          return (
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "4px 10px",
                borderRadius: "5px",
                color: isRunning ? "#92400E" : "#64748B",
                background: isRunning ? "#FEF3C7" : "#F1F5F9",
              }}
            >
              <div
                style={{
                  width: "7px",
                  height: "7px",
                  borderRadius: "50%",
                  background: isRunning ? "#F59E0B" : "#94A3B8",
                }}
              ></div>
              <div>{isRunning ? "Running" : "Idle"}</div>
            </div>
          );
        },
      },
      // {
      //   Header: t("sopmanagementtableheaders.tasklist"),
      //   accessor: "task_list",
      //   disableSortBy: true,
      // },
      // {
      //   Header: t("sopmanagementtableheaders.resourcelist"),
      //   accessor: "resource_list",
      //   Cell: (props) => {
      //     if (props && props.value) {
      //       if (props.value.length > 0) {
      //         return getShortenedText(15, props.value);
      //       }
      //     } else {
      //       return "NA";
      //     }
      //   },
      //   disableSortBy: true,
      // },
      {
        Header: t("sopmanagementtableheaders.createdon"),
        accessor: "created_on",
        disableSortBy: false, // Enable sorting
        sortType: (rowA, rowB, columnId) => {
          const dateA = new Date(rowA.values[columnId]);
          const dateB = new Date(rowB.values[columnId]);
          return dateB - dateA; // Newest first
        },
        Cell: (props) => {
          if (props && props.value) {
            return <Moment format="DD-MM-YYYY, hh:mm A">{props.value}</Moment>;
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("sopmanagementtableheaders.action"),
        disableSortBy: true,
        Cell: (props) => {
          const [isdelete, setIsdelete] = useState(false);
          const deletePopUp = () => {
            setIsdelete(!isdelete);
          };
          const deleteTableDataById = async (id) => {
            let data = { id: id };
            var res = await putDataWithBody(deleteSopById, data, {});
            if (res.status == "success") {
              getSOPMasterList();
            }
            toast.success(res.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000, // Close after 2 seconds
            });
            setIsdelete(false);
          };

          const { is_running } = props.row.original; // SOP Status column's own flag
          const isDisabled = is_running === true; // Running SOPs can't be edited/deleted
          const disabledTitle = "This action is disabled while the SOP is Running. Stop the SOP to edit or delete it.";
          // Inactive (deleted) SOPs are shown in their own table with view /
          // audit-history only — no edit or delete.
          const rowDeleted = props.row.original.isDeleted === true;

          return (
            <div className="usertable__actionsicon">
              {/* View Button (Always Enabled) */}
              <span
                onClick={() =>
                  navigate("/planning/view-sopinfo", {
                    state: { data: props.row.original },
                  })
                }
                title="View"
              >
                <Viewicon value={props.value} className="cursor-pointer me-2" />
              </span>

              {/* Audit History Button (Always Enabled) */}
              <span
                className="cursor-pointer me-2"
                title="Audit History"
                onClick={() => setHistoryRow(props.row.original)}
              >
                <HistoryIcon size={14} title="Audit History" />
              </span>

              {/* Edit Button (Disabled while the SOP is Running, hidden for inactive SOPs) */}
              {!rowDeleted && (
                <span
                  onClick={() =>
                    !isDisabled &&
                    navigate("/planning/create-sop", {
                      state: { data: props.row.original,
                      edit: true
                       },
                    })
                  }
                  title={isDisabled ? disabledTitle : "Edit"}
                  style={{
                    opacity: isDisabled ? 0.5 : 1, // Make it look faded
                    cursor: isDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <Editicon value={props.value} className={isDisabled ? "me-2" : "cursor-pointer me-2"} />
                </span>
              )}

              {/* Delete Button (Only for SUPER_ADMIN, disabled while the SOP is Running, hidden for inactive SOPs) */}
              {roleName === process.env.REACT_APP_SUPER_ADMIN && !rowDeleted && (
                <span
                  onClick={() => !isDisabled && deletePopUp()}
                  title={isDisabled ? disabledTitle : "Delete"}
                  style={{
                    opacity: isDisabled ? 0.5 : 1, // Make it look faded
                    cursor: isDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <Deleteicon
                    value={props.value}
                    className={isDisabled ? "mr-1" : "cursor-pointer mr-1"}
                  />
                </span>
              )}

              {/* Delete Confirmation Popup */}
              {isdelete && (
                <Confirmpopup
                  className="DeltePopup"
                  show={isdelete}
                  title={t("deletepopuptext")}
                  message={t("deletepopupmessage")}
                  handleToggle={deletePopUp}
                  row={props.row}
                  name={props.row.original.task}
                  deleteRow={deleteTableDataById}
                  cancel={t("cancelbutton")}
                  action={t("actionbutton")}
                />
              )}
            </div>
          );
        },
      },
    ],
    [t, roleName]
  );

  const categoryOptions = React.useMemo(
    () => Array.from(new Set(SOPData.map((r) => r.incident_type).filter(Boolean))).sort(),
    [SOPData]
  );
  const severityOptions = React.useMemo(
    () => Array.from(new Set(SOPData.map((r) => r.severity).filter(Boolean))).sort(),
    [SOPData]
  );

  const isDateRangeInvalid =
    !!pendingDateFrom && !!pendingDateTo && new Date(pendingDateFrom) > new Date(pendingDateTo);

  const handleApplyDateFilter = () => {
    if (isDateRangeInvalid) return;
    setAppliedDateFrom(pendingDateFrom);
    setAppliedDateTo(pendingDateTo);
  };

  const filteredSOPData = React.useMemo(() => {
    return SOPData.filter((row) => {
      if (categoryFilter !== "All" && row.incident_type !== categoryFilter) return false;
      if (severityFilter !== "All" && row.severity !== severityFilter) return false;
      if (statusFilter !== "All") {
        const isRunning = row.is_running === true;
        if (statusFilter === "Running" && !isRunning) return false;
        if (statusFilter === "Idle" && isRunning) return false;
      }
      if (appliedDateFrom || appliedDateTo) {
        if (!row.created_on) return false;
        const created = new Date(row.created_on);
        if (appliedDateFrom && created < new Date(`${appliedDateFrom}T00:00:00`)) return false;
        if (appliedDateTo && created > new Date(`${appliedDateTo}T23:59:59`)) return false;
      }
      return true;
    });
  }, [SOPData, categoryFilter, severityFilter, statusFilter, appliedDateFrom, appliedDateTo]);

  const hasActiveFilters =
    categoryFilter !== "All" ||
    severityFilter !== "All" ||
    statusFilter !== "All" ||
    appliedDateFrom !== "" ||
    appliedDateTo !== "";

  const clearAllFilters = () => {
    setCategoryFilter("All");
    setSeverityFilter("All");
    setStatusFilter("All");
    setPendingDateFrom("");
    setPendingDateTo("");
    setAppliedDateFrom("");
    setAppliedDateTo("");
  };

  const buildSopExportRows = () => {
    const rows = [];
    filteredSOPData.forEach((row) => {
      const common = {
        "SOP Master ID": row.sopmaster_seq_id || "NA",
        "SOP Name": row.name || "NA",
        "Incident Category": row.incident_type || "NA",
        Severity: row.severity || "NA",
        "SOP Status": row.is_running === true ? "Running" : "Idle",
        "Created On": row.created_on
          ? (() => {
              const d = new Date(row.created_on);
              const pad = (n) => String(n).padStart(2, "0");
              const hours12 = d.getHours() % 12 || 12;
              const ampm = d.getHours() < 12 ? "AM" : "PM";
              return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}, ${pad(hours12)}:${pad(d.getMinutes())} ${ampm}`;
            })()
          : "NA",
      };
      const resources = row.resources || [];
      if (resources.length === 0) {
        rows.push({
          ...common,
          "Resource Name": "NA",
          "Available Qty": "NA",
          "Damaged Qty": "NA",
          "Deployed Qty": "NA",
          "Total Qty": "NA",
          "Qty To Deploy": "NA",
          Auto: "NA",
          Manual: "NA",
        });
        return;
      }
      resources.forEach((resource) => {
        rows.push({
          ...common,
          "Resource Name": resource.resource_name || "NA",
          "Available Qty": resource.cum_available_quantity ?? resource.available_quantity ?? "0",
          "Damaged Qty": resource.cum_damaged_quantity ?? "0",
          "Deployed Qty": resource.cum_deployed_quantity ?? "0",
          "Total Qty": resource.cum_total_quantity ?? "0",
          "Qty To Deploy": resource.quantity ?? resource.required_quantity ?? "0",
          Auto: isTruthyFlagYesNo(resource.is_automatic),
          Manual: isTruthyFlagYesNo(resource.is_manual),
        });
      });
    });
    return rows;
  };

  const handleExportSopExcel = async () => {
    const rows = buildSopExportRows();
    if (!rows.length) {
      toast.info("No data to export");
      return;
    }
    const workbook = new ExcelJS.Workbook();
    const ws = workbook.addWorksheet("SOP List");
    const headerRow = ws.addRow(SOP_LIST_EXPORT_COLUMNS);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2E6DA4" } };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
    });
    rows.forEach((r) => {
      const dataRow = ws.addRow(SOP_LIST_EXPORT_COLUMNS.map((col) => r[col]));
      dataRow.eachCell((cell) => {
        cell.alignment = { horizontal: "left", vertical: "middle" };
        cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
      });
    });
    ws.columns.forEach((col) => { col.width = 22; });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, `SOP_List_${exportFileStamp()}.xlsx`);
  };

  const handleExportSopPDF = () => {
    const rows = buildSopExportRows();
    if (!rows.length) {
      toast.info("No data to export");
      return;
    }
    const doc = new jsPDF("l", "pt", "a4");
    const pageWidth = doc.internal.pageSize.width;
    doc.setFontSize(13);
    doc.text("SOP List", pageWidth / 2, 40, { align: "center" });
    doc.autoTable({
      head: [SOP_LIST_EXPORT_COLUMNS],
      body: rows.map((r) => SOP_LIST_EXPORT_COLUMNS.map((c) => String(r[c] ?? ""))),
      startY: 60,
      theme: "grid",
      styles: { fontSize: 8, cellPadding: 3, overflow: "linebreak" },
      headStyles: { fillColor: [46, 109, 164], textColor: [255, 255, 255], fontStyle: "bold", halign: "center", fontSize: 8 },
      margin: { left: 20, right: 20 },
    });
    doc.save(`SOP_List_${exportFileStamp()}.pdf`);
  };

  return (
    <div className="create-user">
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />
      <div
        style={{
          position: "relative",
          background: "#fff",
          border: "1px solid #EEF1F5",
          borderRadius: "10px 10px 0 0",
          padding: "10px 14px",
        }}
      >
        <div style={{ position: "absolute", top: "10px", right: "14px", display: "flex", gap: "8px", zIndex: 2 }}>
          <button
            type="button"
            title="Download Excel"
            style={filteredSOPData.length ? excelExportBtnStyle : exportBtnDisabledStyle}
            onClick={handleExportSopExcel}
            disabled={!filteredSOPData.length}
          >
            <Sheet size={15} />
          </button>
          <button
            type="button"
            title="Download PDF"
            style={filteredSOPData.length ? pdfExportBtnStyle : exportBtnDisabledStyle}
            onClick={handleExportSopPDF}
            disabled={!filteredSOPData.length}
          >
            <FileText size={15} />
          </button>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
          <span
            style={{
              width: "20px", height: "20px", borderRadius: "6px", background: "#EBF4FA",
              display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
            }}
          >
            <FilterIcon size={11} color="#2E6DA4" />
          </span>
          <span style={{ fontSize: "12px", fontWeight: 800, color: "#2E6DA4" }}>Filters</span>
        </div>
        <style>{`
          .sop-list-filter-bar input[type="date"] {
            position: relative;
            padding-right: 30px;
            display: inline-flex;
            align-items: center;
          }
          .sop-list-filter-bar input[type="date"]::-webkit-datetime-edit {
            display: inline-flex;
            align-items: center;
            padding: 0;
            line-height: normal;
          }
          .sop-list-filter-bar input[type="date"]::-webkit-datetime-edit-fields-wrapper {
            display: inline-flex;
            align-items: center;
          }
          .sop-list-filter-bar input[type="date"]::-webkit-calendar-picker-indicator {
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translateY(-50%);
            margin: 0;
            padding: 0;
            cursor: pointer;
            opacity: 0.55;
          }
          .sop-list-filter-bar input[type="date"]::-webkit-inner-spin-button,
          .sop-list-filter-bar input[type="date"]::-webkit-clear-button {
            display: none;
          }
        `}</style>
        <div className="sop-list-filter-bar" style={{ display: "flex", gap: "14px", flexWrap: "wrap", alignItems: "flex-end" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 200px" }}>
            <label style={filterLabelStyle}>Incident Category</label>
            <select value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)} style={{ ...filterControlStyle, width: "100%" }}>
              <option value="All">Incident Category</option>
              {categoryOptions.map((c) => (<option key={c} value={c}>{c}</option>))}
            </select>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 200px" }}>
            <label style={filterLabelStyle}>Severity</label>
            <select value={severityFilter} onChange={(e) => setSeverityFilter(e.target.value)} style={{ ...filterControlStyle, width: "100%" }}>
              <option value="All">Severity</option>
              {severityOptions.map((s) => (<option key={s} value={s}>{s}</option>))}
            </select>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 160px" }}>
            <label style={filterLabelStyle}>SOP Status</label>
            <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} style={{ ...filterControlStyle, width: "100%" }}>
              <option value="All">SOP Status</option>
              <option value="Running">Running</option>
              <option value="Idle">Idle</option>
            </select>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 160px" }}>
            <label style={filterLabelStyle}>Created From</label>
            <input
              type="date"
              value={pendingDateFrom}
              max={pendingDateTo && pendingDateTo < TODAY_STR ? pendingDateTo : TODAY_STR}
              onChange={(e) => setPendingDateFrom(clampToToday(e.target.value))}
              style={{ ...filterControlStyle, width: "100%" }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 160px" }}>
            <label style={filterLabelStyle}>Created To</label>
            <input
              type="date"
              value={pendingDateTo}
              min={pendingDateFrom || undefined}
              max={TODAY_STR}
              onChange={(e) => setPendingDateTo(clampToToday(e.target.value))}
              style={{ ...filterControlStyle, width: "100%" }}
            />
          </div>
          <button
            type="button"
            onClick={handleApplyDateFilter}
            disabled={!pendingDateFrom || !pendingDateTo || isDateRangeInvalid}
            title="Applies the Created From / Created To date range"
            style={{
              height: "34px", padding: "0 16px", borderRadius: "6px", fontSize: "12px", fontWeight: 600,
              border: "1px solid #2E6DA4",
              background: (!pendingDateFrom || !pendingDateTo || isDateRangeInvalid) ? "#a9c3d8" : "#2E6DA4",
              color: "#fff",
              cursor: (!pendingDateFrom || !pendingDateTo || isDateRangeInvalid) ? "not-allowed" : "pointer",
            }}
          >
            Apply
          </button>
          {hasActiveFilters && (
            <button
              type="button"
              onClick={clearAllFilters}
              style={{ height: "34px", padding: "0 12px", borderRadius: "8px", border: "1px solid #E4E7EC", background: "#F9FAFB", color: "#475467", fontSize: "12px", fontWeight: 600, cursor: "pointer" }}
            >
              Clear Filters
            </button>
          )}
        </div>
        {isDateRangeInvalid && (
          <div style={{ marginTop: "8px", fontSize: "11px", color: "#DC2626", fontWeight: 600 }}>
            "Created From" date must be on or before "Created To" date.
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          gap: "8px",
          padding: "10px 16px",
          borderLeft: "4px solid #2E6DA4",
          background: "#f4f8fb",
          borderBottom: "1px solid #e5e9ef",
        }}
      >
        <span style={{ fontSize: "12px", fontWeight: 700, color: "#1a2e35", letterSpacing: ".2px" }}>
          Active SOPs
        </span>
        <span style={{ fontSize: "10.5px", color: "#5b6b7a" }}>
          Live SOPs — create, edit, view and audit history
        </span>
      </div>
      <div className="datatable__container">
        {SOPTableData && (
          <SOPExpandableTable
            data={filteredSOPData}
            columns={columns}
            numberOfRows={10}
            showRowCount={true}
            rowCount={filteredSOPData.length}
            showReset={false}
            showExport={false}
            showResourceQuantities={true}
            chevronToggle={true}
            headerTableHeadStyle={{ background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid #f0f0f0",
              borderTop: "none",
              borderBottom: inactiveSOPData.length > 0 ? "none" : "1px solid #f0f0f0",
              borderRadius: inactiveSOPData.length > 0 ? "0" : "0 0 12px 12px",
            }}
          />
        )}
      </div>

      {inactiveSOPData.length > 0 && (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              gap: "8px",
              padding: "10px 16px",
              marginTop: "18px",
              borderLeft: "4px solid #94a3b8",
              borderTop: "1px solid #e5e9ef",
              borderBottom: "1px solid #e5e9ef",
              background: "#f4f5f7",
            }}
          >
            <span style={{ fontSize: "12px", fontWeight: 700, color: "#5b6b7a", letterSpacing: ".2px" }}>
              Inactive SOPs
            </span>
            <span style={{ fontSize: "10.5px", color: "#8a97a3" }}>
              Deleted SOPs — view and audit history only
            </span>
          </div>
          <div className="datatable__container" style={{ paddingBottom: "12px" }}>
            <SOPExpandableTable
              data={inactiveSOPData}
              columns={columns}
              numberOfRows={10}
              showRowCount={true}
              rowCount={inactiveSOPData.length}
              showSearch={false}
              showReset={false}
              showExport={false}
              showResourceQuantities={true}
              chevronToggle={true}
              markDeletedRows={false}
              headerTableHeadStyle={{ background: "linear-gradient(120deg, #64748b 0%, #94a3b8 100%)", color: "#FFFFFF" }}
              tableStyle={{
                border: "1px solid #f0f0f0",
                borderTop: "none",
                borderRadius: "0 0 12px 12px",
              }}
            />
          </div>
        </>
      )}

      <Modal show={show} size="lg" className="table__modal__popup" centered>
        <Modal.Header>
          <Modal.Title>SOP Data</Modal.Title>
          <XCircleblack
            className="cursor-pointer"
            onClick={hideModal}
            width="1.5em"
            height="1.5em"
          />
        </Modal.Header>
        <Modal.Body>
          <div className="create__resource--popup">
            <div class="form-group">
              <Table
                data={SOPData}
                columns={columns}
                numberOfRows={5}
                showExport={false}
                showFilter={false}
                showReset={false}
                onExpand={false}
                headerTableHeadStyle={{
                  background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
                  color: "#FFFFFF",
                }}
                tableStyle={{ border: "none", padding: "0px" }}
              />
            </div>
            <div class="form-group">
              <Table
                data={SOPData}
                columns={columns}
                numberOfRows={5}
                showExport={false}
                showFilter={false}
                showReset={false}
                onExpand={false}
                headerTableHeadStyle={{
                  background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
                  color: "#FFFFFF",
                }}
                tableStyle={{ border: "none", padding: "0px" }}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      <SopResourceAuditHistoryModal
        show={!!historyRow}
        onClose={() => setHistoryRow(null)}
        sopMasterId={historyRow?.id}
        sopName={historyRow?.name}
        sopMasterSeqId={historyRow?.sopmaster_seq_id}
        incidentType={historyRow?.incident_type}
        severity={historyRow?.severity}
      />
    </div>
  );
});

export default SOPTable;
